import React, { useMemo } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { Picker } from '../../root/components/common'
import { getSystemIds } from '../api/device-api'
import { OPERATION_MODES_PEST_CONTROL_SYSTEMS } from '../../root/constants'
import { useDispatch } from 'react-redux'
import { getSagasMsgs } from '../../root/selectors'
import { enqueueSnackbar } from '../../root/actions'

export const SystemTypeSelect = ({
    disabled,
    onChange,
    systemType,
    operationMode
}) => {
    const dispatch = useDispatch()
    const sagasMsgs = useSelector(getSagasMsgs)

    const { isLoading, data = [] } = useQuery('system-ids', getSystemIds, {
        refetchInterval: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        onError: e =>
            dispatch(
                enqueueSnackbar({
                    message: sagasMsgs.getPestControlSystems,
                    options: {
                        variant: 'error'
                    }
                })
            )
    })
    const { locale } = useSelector(state => state.main)
    if (!OPERATION_MODES_PEST_CONTROL_SYSTEMS[operationMode]) return []

    const options = useMemo(
        () =>
            data
                .filter(optData =>
                    OPERATION_MODES_PEST_CONTROL_SYSTEMS[
                        operationMode
                    ].includes(Number(optData.id))
                )
                .reduce((acc, cur) => {
                    acc[cur.id] = locale.devices.pestControlSystems[cur.id]
                    return acc
                }, {}),
        [data, locale]
    )

    return (
        <Picker
            isWithEmptyValue
            emptyValue={null}
            isWithEmptyValueText={`-- ${locale.devices.pestControlSystemNotSelected} --`}
            disabled={disabled || isLoading}
            onChange={onChange}
            value={systemType}
            options={options}
        />
    )
}
